enum WorkoutTrackingApp {
  Yes = "Yes",
  Not_right_now="I have in the past",
  No = "No",

}

const workoutTrackingAppQuestion = {
  name: "workouttrackingapp",
  descriptionLocation: "underTitle",
  title: `Do you currently use a <div class='highlight'>workout tracking</div> app?`,
  description: 'This helps us understand where you’re starting from.',
  type: "radiogroup",
  choices: Object.values(WorkoutTrackingApp),
  isRequired: true,
};

export { WorkoutTrackingApp, workoutTrackingAppQuestion };
